export default "<legend class=\"fadein-03-1s question blanc text-center\" [innerHtml]=\"agefiphService.q.question\"></legend>\r\n";